import React, { useEffect, useMemo, useState } from "react";
import {
  CustomButton,
  CustomDropdown,
  CustomDatePicker,
  CustomTextInput,
} from "../../../components";
import styles from "./examMarkEntry.module.css";
import { useDispatch, useSelector } from "react-redux";
import AxiosInstance, {
  IMAGE_BASE_URL,
  TokenService,
} from "../../../services/Api";
import { useNavigate } from "react-router-dom";
import { fetchStaffClassAndSubjects } from "../../../redux/Masterdata";
import dayjs from "dayjs";
import moment from "moment";
import { FaUser } from "react-icons/fa";
import BlobImage from "../../../components/BlobImage/BlobImage";
import PopupModal from "../../../components/PopupModal/PopupModal";

function ExamMarkEntryCreate() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedExamName, setSelectedExamName] = useState("");
  const [selectedModeOfName, setSelectedModeOfName] = useState("");
  const [buttonHide, setButtonHide] = useState(true);
  const { translations } = useSelector((state) => state.language);
  const user = TokenService.getUser();
  const userId = user?.id || 0;
  const clientData = user?.client_data[0] || {};
  const client_id = clientData?.client_id || "";
  const staff_id = clientData?.master_id;
  const school_id = clientData?.school_id || "";
  const academic_year = clientData?.academic_year || "";
  const academic_year_id = clientData?.academic_year_id || "";
  const [submitted, setSubmitted] = useState(false);

  const [examData, setExamData] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [classSubjectList, setClassSubjectList] = useState([]);
  const [errors, setErrors] = useState({});
  const [markErrors, setMarkErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiSearch, setApiSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [tableData, setTableData] = useState();
  const [studentData, setStudentData] = useState([]);
  const [modalState, setModalState] = useState({
    open: false,
    type: "success", // "success" | "error"
    message: "",
    redirectPath: "",
  });

  const {
    staffClassAndSubjectOptions: reduxClassOptions,
    sectionOptions: reduxSectionOptions,
  } = useSelector((state) => state.masterData);
  useEffect(() => {
    if (school_id) {
      fetchExamConfigList();
    }
  }, school_id);
  const fetchExamConfigList = async () => {
    setLoading(true);
    try {
      const payload = {
        school_id: parseInt(school_id),
        academic_year: parseInt(academic_year_id),
      };

      const response = await AxiosInstance.post(
        `/exam/examConfig/list`,
        payload,
      );

      if (response?.data?.status) {
        const examData = response.data.data || [];
        const transformedData = examData.map((item, index) => ({
          id: item.id,
          sno: index + 1,
          academic_id: item.academic_id,
          academic_year: item.academic_year,
          exam_type: item.exam_type,
          start_date: item.start_date
            ? dayjs(item.start_date).format("DD-MM-YYYY")
            : "",
          end_date: item.end_date
            ? dayjs(item.end_date).format("DD-MM-YYYY")
            : "",
          isActive: item.isActive,
        }));
        setExamData(transformedData);
      } else {
        setExamData([]);
      }
    } catch (error) {
      console.error("Error fetching exam config list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(
      fetchStaffClassAndSubjects({
        //    staff_id: parseInt(staff_id),
        staff_id: staff_id,
        class_id: selectedClass?.value || "",
        section_id: selectedSection?.value || "",
        subject_id: selectedSubject?.value || "",
      }),
    );
  }, [dispatch, school_id, selectedClass, selectedSection, selectedSubject]);

  const validateForm = () => {
    const newErrors = {};
    if (!selectedClass) newErrors.class = translations.errors.classRequired;
    if (!selectedExamName)
      newErrors.examName = translations.errors.examNameRequired;
    if (!selectedModeOfName)
      newErrors.modeOfName = translations.errors.modeOfNameRequired;

    if (!selectedSection)
      newErrors.section = translations.errors.sectionRequired;
    if (!selectedSubject)
      newErrors.subject = translations.errors.subjectRequired;

    return newErrors;
  };
  const handleRefresh = () => {
    setSelectedClass("");
    setSelectedSection("");
    setSelectedSubject("");
    setSelectedExamName("");
    setSelectedModeOfName("");
  };
  const handleCancel = () => {
    navigate("/user/exams/marks");
  };
  const handleCheck = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const validationErrors = validateForm();

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      const payload = {
        staff_id: staff_id,
        config_id: selectedExamName?.value || "",
        school_id: school_id,
        class_id: selectedClass?.value || "",
        section_id: selectedSection?.value || "",
        subject_id: selectedSubject?.value || "",
        mode_exam: selectedModeOfName?.label || "",
      };
      const response = await AxiosInstance.post(
        `/exam/examMarkEntry/checkExam`,
        payload,
      );
      if (response.data?.status) {
        setButtonHide(false);
        setTableData(response.data.data[0]);
      } else {
        setModalState({
          open: true,
          type: "error",
          message: response?.data?.message || "Something went wrong!",
          redirectPath: "",
        });
        // ✅ graceful handling
        setTableData([]);

        // alert(response.data?.message || "No data found");
      }
    }
  };
  const handleDraft = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    let errors = {};
    studentData.forEach((student) => {
      if (!student.score && student.score !== 0) {
        errors[student.student_id] = "Mark is required";
      } else if (Number(student.score) > tableData?.max_marks) {
        errors[student.student_id] =
          `Mark cannot exceed ${tableData?.max_marks}`;
      } else if (Number(student.score) < 0) {
        errors[student.student_id] = "Mark cannot be negative";
      }
    });
    setMarkErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }
    const marksDetails = studentData.map((student) => ({
      student_id: student.student_id,
      marks: Number(student.score) || 0, // convert to number
    }));
    // if (Object.keys(validationErrors).length === 0) {
    const payload = {
      client_id: client_id,
      academic_id: academic_year_id,
      staff_id: staff_id,
      config_id: selectedExamName?.value || "",
      school_id: school_id,
      class_id: selectedClass?.value || "",
      section_id: selectedSection?.value || "",
      subject_id: selectedSubject?.value || "",
      modeof_exam: selectedModeOfName?.label || "",
      campus_exam_schedule_id: tableData?.id,
      exam_date: moment(tableData?.date).format("DD-MM-YYYY"),
      marks_details: marksDetails,
      min_marks: tableData?.pass_marks,
      max_marks: tableData?.max_marks,
      isActive: 1,
      created_by: userId,
    };
    const response = await AxiosInstance.post(
      `/exam/examMarkEntry/create`,
      payload,
    );
    if (response.data?.status) {
      setModalState({
        open: true,
        type: "success",
        message: response.data?.message || "Mark Entry created successfully",
        redirectPath: "/user/exams/marks",
      });
    } else {
      console.log("No Data");
      setModalState({
        open: true,
        type: "error",
        message: response?.data?.message || "Something went wrong!",
        redirectPath: "",
      });
      // ✅ graceful handling

      // alert(response.data?.message || "No data found");
    }
    // }
  };
  const handleSEarchStudent = async (e) => {
    e.preventDefault();
    const payload = {
      staff_id: staff_id,
      school_id: school_id,
      class_id: selectedClass?.value || "",
      section_id: selectedSection?.value || "",
      subject_id: selectedSubject?.value || "",
      academic_year: academic_year_id,
    };
    const response = await AxiosInstance.post(
      `/exam/examMarkEntry/staff/students`,
      payload,
    );
    if (response.data?.status) {
      setButtonHide(false);
      setStudentData(response.data.data);
    } else {
      setStudentData([]);
      setModalState({
        open: true,
        type: "error",
        message: response?.data?.message || "Something went wrong!",
        redirectPath: "",
      });
    }
  };
  // Options List
  const classOptions = useMemo(() => {
    const seen = new Set();
    return (reduxClassOptions || [])
      .filter((item) => {
        const key = String(item.class_id);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .map((item) => ({
        value: String(item.class_id),
        label: item.class_name,
      }));
  }, [reduxClassOptions]);
  const sectionOptions = useMemo(() => {
    if (!selectedClass) return [];
    const classId =
      typeof selectedClass === "object" ? selectedClass?.value : selectedClass;
    const seen = new Set();
    return (reduxClassOptions || [])
      .filter((item) => {
        if (String(item.class_id) !== String(classId)) return false;
        const key = String(item.section_id);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .map((item) => ({
        value: String(item.section_id),
        label: String(item.section_id),
      }));
  }, [reduxClassOptions, selectedClass]);

  const subjectOptions = useMemo(
    () => [
      {
        value: "",
        label: translations.labels?.selectSubject || "Select Class",
      },
      ...reduxClassOptions.map((item) => ({
        value: item.subject_id,
        label: item.subject_name,
      })),
    ],
    [reduxClassOptions, translations],
  );
  const examOptions = examData.map((item) => ({
    label: item.exam_type, // what shows in dropdown
    value: item.id, // what gets stored in formData
  }));

  const modeOptions = [
    { label: "Theory", value: 1 },
    { label: "Practical", value: 2 },
  ];

  // onChange
  const handleClassChange = (value) => {
    setSelectedClass(value);
    setSelectedSection("");

    setErrors((prev) => ({
      ...prev,
      class: "",
    }));
  };
  const handleSectionChange = (value) => {
    setSelectedSection(value);

    setErrors((prev) => ({
      ...prev,
      section: "",
    }));
  };
  const handleSubjectChange = (value) => {
    setSelectedSubject(value);

    setErrors((prev) => ({
      ...prev,
      subject: "",
    }));
  };
  const handleExamNameChange = (value) => {
    setSelectedExamName(value);

    setErrors((prev) => ({
      ...prev,
      examName: "",
    }));
  };
  const handleModeOfNameChange = (value) => {
    setSelectedModeOfName(value);

    setErrors((prev) => ({
      ...prev,
      modeOfName: "",
    }));
  };
  const handleMarkChange = (studentId, value) => {
    // Allow empty value for clearing
    if (value === "") {
      setStudentData((prev) =>
        prev.map((student) =>
          student.student_id === studentId
            ? { ...student, score: value }
            : student,
        ),
      );
      // Clear error for this student
      setMarkErrors((prev) => ({ ...prev, [studentId]: "" }));
      return;
    }

    // Convert to number for validation
    const numValue = Number(value);

    // Check if it's a valid number
    if (isNaN(numValue)) {
      return;
    }

    // Check for negative numbers
    if (numValue < 0) {
      setModalState({
        open: true,
        type: "error",
        message: "Marks cannot be negative",
        redirectPath: "",
      });
      return;
    }

    // Check if exceeding max marks
    if (tableData?.max_marks && numValue > tableData.max_marks) {
      setModalState({
        open: true,
        type: "error",
        message: `Marks cannot exceed ${tableData.max_marks}`,
        redirectPath: "",
      });
      return;
    }

    // Valid mark - update the state
    setStudentData((prev) =>
      prev.map((student) =>
        student.student_id === studentId
          ? { ...student, score: value }
          : student,
      ),
    );

    // Clear any previous error for this student
    setMarkErrors((prev) => ({ ...prev, [studentId]: "" }));
  };
  const handleSuccessOk = () => {
    const { type, redirectPath } = modalState;
    setModalState((prev) => ({
      ...prev,
      open: false,
    }));
    if (type === "success" && redirectPath) {
      navigate(redirectPath);
    }
  };
  return (
    <>
      <PopupModal
        open={modalState.open}
        title={modalState.type === "success" ? "Success" : "Failed"}
        message={modalState.message}
        onOk={handleSuccessOk}
      />
      <div className={styles.container}>
        <form onSubmit={handleCheck} className="row g-3 align-items-center">
          {/* Class */}
          <div className="col-lg-3 px-2 col-md-6 col-sm-12">
            <CustomDropdown
              label={translations.labels.class}
              name="classValue"
              value={selectedClass}
              onChange={handleClassChange}
              options={classOptions}
              placeholder={translations.labels.selectClass}
              required
              error={submitted && errors.class}
              isSearchable={false}
            />
          </div>

          {/* Section */}

          <div className="col-lg-3 px-2 col-md-6 col-sm-12">
            <CustomDropdown
              label={translations.labels.section}
              name="section"
              value={selectedSection}
              options={sectionOptions}
              onChange={handleSectionChange}
              placeholder={translations.labels.selectSection}
              required
              error={submitted && errors.section}
              isSearchable={false}
            />
          </div>
          {/* Subject */}

          <div className="col-lg-3 px-2 col-md-6 col-sm-12">
            <CustomDropdown
              label={translations.labels.subject}
              name="subject"
              value={selectedSubject}
              options={subjectOptions}
              onChange={handleSubjectChange}
              placeholder={translations.labels.selectsubjectPlaceholder}
              required
              error={submitted && errors.subject}
              isSearchable={false}
            />
          </div>

          {/* Exam Name */}
          <div className="col-lg-3 px-2 col-md-6 col-sm-12">
            <CustomDropdown
              label={translations.labels.examName || "Exam Name"}
              name="examName"
              value={selectedExamName}
              onChange={handleExamNameChange}
              options={examOptions}
              placeholder={translations.labels.selectsubjectPlaceholder}
              required
              error={submitted && errors.examName}
              isSearchable={false}
            />
          </div>

          {/* Exam Mode */}
          <div className="col-lg-3 px-2 col-md-6 col-sm-12 mt-3">
            <CustomDropdown
              label={translations.labels.modeOfName || "Exam Mode"}
              name="modeOfName"
              value={selectedModeOfName}
              onChange={handleModeOfNameChange}
              options={modeOptions}
              placeholder={translations.labels.selectsubjectPlaceholder}
              required
              error={submitted && errors.modeOfName}
              isSearchable={false}
            />
          </div>

          {!buttonHide && (
            <>
              <div className="col-lg-3 col-md-6 col-sm-12 px-2">
                <CustomTextInput
                  label={translations.labels.passMark || "Pass Mark"}
                  // type="number"
                  value={tableData?.pass_marks}
                  disabled
                  required
                  error={errors.day}
                />
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 px-2">
                <CustomTextInput
                  label={translations.labels.maxMark || "Max Makr"}
                  // type="number"
                  value={tableData?.max_marks}
                  disabled
                  required
                />
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 px-2">
                <CustomTextInput
                  label={translations.labels.examDate || "Exam Date"}
                  // type="number"
                  value={moment(tableData?.date).format("DD-MM-YYYY")}
                  disabled
                  required
                />
              </div>
            </>
          )}
          {buttonHide && (
            <div className="col-lg-3 px-2 col-md-6 col-sm-12 mt-3 ">
              <div className="d-flex gap-2 w-100">
                <CustomButton
                  variant="contained"
                  onClick={handleCheck}
                  className={styles.saveButton}
                  loading={loading}
                >
                  {translations.labels.checkExamButton}
                </CustomButton>

                <CustomButton
                  variant="contained"
                  onClick={handleRefresh}
                  className={styles.cancelButton}
                  disabled={loading}
                >
                  {translations.labels.refreshButton}
                </CustomButton>
              </div>
            </div>
          )}

          {!buttonHide && (
            <div className="col-md-12 pt-3 d-flex justify-content-start align-items-center ">
              <div className="d-flex gap-3">
                <CustomButton
                  variant="contained"
                  onClick={handleSEarchStudent}
                  className={styles.saveButton}
                  loading={loading}
                >
                  {translations.labels.searchStudents || "Search Students"}
                </CustomButton>
              </div>
            </div>
          )}

          <div className={styles.wrapper}>
            {studentData.map((user, index) => (
              <div key={user.id} className={styles.card}>
                {/* Left Section */}
                <div className={styles.leftSection}>
                  <div className={styles.avatarWrapper}>
                    <div className={styles.avatar}>
                      {user.student_profile ? (
                        <BlobImage
                          path={user.student_profile}
                          alt={user.name}
                          className={styles.profileImage}
                        />
                      ) : (
                        <FaUser className={styles.defaultIcon} />
                      )}
                    </div>
                  </div>

                  <div>
                    <div className={styles.phone}>{user.student_id}</div>
                    <div className={styles.name}>{user.name}</div>
                  </div>
                </div>

                {/* Right Section */}
                <div className={styles.rightSection}>
                  <input
                    type="number"
                    className={styles.markInput}
                    value={user.score || ""}
                    onChange={(e) =>
                      handleMarkChange(user.student_id, e.target.value)
                    }
                    min="0"
                    max={tableData?.max_marks}
                    step="1"
                  />

                  {markErrors[user.student_id] && (
                    <div className={styles.errorText}>
                      {markErrors[user.student_id]}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          {studentData.length > 0 && (
            <div className="col-md-12 pt-3 d-flex justify-content-center align-items-center">
              <div className="d-flex gap-3">
                <CustomButton
                  variant="contained"
                  onClick={handleDraft}
                  className={styles.saveButton}
                  loading={loading}
                >
                  {translations.labels.saveDraftButton || "Save To Draft"}
                </CustomButton>

                <CustomButton
                  variant="contained"
                  onClick={handleCancel}
                  className={styles.cancelButton}
                  disabled={loading}
                >
                  {translations.labels.cancelButton}
                </CustomButton>
              </div>
            </div>
          )}
        </form>
      </div>
    </>
  );
}

export default ExamMarkEntryCreate;
